import { useParentEl } from './useParentEl';
import { __SYS_COMMON_FIELD__, __CLASS_CSR_CMP__ } from '@/const/ssrClass';

// 监听当前字段变化
export const useSiblingField = (currentEl, cmpName) => {
    const parentEl = useParentEl(currentEl, __SYS_COMMON_FIELD__);
    const siblingFieldEl = parentEl.parentElement.querySelector(`.${__CLASS_CSR_CMP__}[data-cmp="${cmpName}"]`);
    return siblingFieldEl;
};
